import { useState } from "react";
import styles from "./PostRaceInput.module.css";
import { useTranslation } from "react-i18next";

export default function PostRace({ value, onChange }) {
  const { t } = useTranslation();
  const [groups, setGroups] = useState(
    value?.data || [
      {
        date: "",
        entries: [{ name: "", value: "" }],
      },
    ]
  );

  const updateGroups = (updated) => {
    setGroups(updated);
    onChange({ data: updated });
  };

  const handleChange = (groupIndex, entryIndex, key, val) => {
    const updated = [...groups];
    updated[groupIndex].entries[entryIndex][key] = val;
    updateGroups(updated);
  };

  const handleDateChange = (groupIndex, val) => {
    const updated = [...groups];
    updated[groupIndex].date = val;
    updateGroups(updated);
  };

  const addDateGroup = () => {
    const updated = [
      ...groups,
      {
        date: "",
        entries: [{ name: "", value: "" }],
      },
    ];
    updateGroups(updated);
  };

  const addEntryToGroup = (groupIndex) => {
    const updated = [...groups];
    updated[groupIndex].entries.push({ name: "", value: "" });
    updateGroups(updated);
  };

  return (
    <div className={styles.pollContainer}>
      {groups.map((group, groupIndex) => (
        <div key={groupIndex} className={styles.dateGroup}>
          <input
            type="text"
            className={styles.optionInput}
            placeholder="Date"
            value={group.date}
            onChange={(e) => handleDateChange(groupIndex, e.target.value)}
          />

          {group.entries.map((entry, entryIndex) => (
            <div key={entryIndex} className={styles.optionRow}>
              <input
                type="text"
                className={styles.optionInput}
                placeholder="Name / Category"
                value={entry.name}
                onChange={(e) =>
                  handleChange(groupIndex, entryIndex, "name", e.target.value)
                }
              />
              <input
                type="text"
                className={styles.optionInput}
                placeholder="Value"
                value={entry.value}
                onChange={(e) =>
                  handleChange(groupIndex, entryIndex, "value", e.target.value)
                }
              />
            </div>
          ))}

          <button
            type="button"
            className={styles.addButton}
            onClick={() => addEntryToGroup(groupIndex)}
          >
            + Add Row
          </button>
        </div>
      ))}

      <button type="button" className={styles.addButton} onClick={addDateGroup}>
        + Add New Date
      </button>
    </div>
  );
}
